import { ReactRenderer } from '@tiptap/react'
import tippy from 'tippy.js'

import MentionList from './MentionList.jsx'
import axios from "axios"

export default {
  items: async ({ query }) => {
    let userListings = []

    let finalServerURL = process.env.REACT_APP_SERVER_URL
    if (process.env.REACT_APP_MODE !== "production") {
      finalServerURL = process.env.REACT_APP_LOCAL_SERVER_URL
    } else if (process.env.REACT_APP_MODE === "production") {
      finalServerURL = process.env.REACT_APP_SERVER_URL
    }


    const getDisticsDepartment = await axios.post(finalServerURL + "/forms/getAnimals")
    if (getDisticsDepartment.status === 200) {

      getDisticsDepartment.data.users.map((userData, key) => {
        return userListings.push(
          {
            id: userData.submittedData["Official Mail Id"], // Unique user ID
            label: `${userData.submittedData["Employee Name"]} (${userData.submittedData["Process / Department"]})`,
          }
        )
      })

      // console.log(userListings)

    } else {
      console.log(getDisticsDepartment.data)
    }
    return userListings.filter((item) => item.label.toLowerCase().startsWith(query.toLowerCase())).slice(0, 5)
  },

  render: () => {
    let component
    let popup

    return {
      onStart: props => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        })

        if (!props.clientRect) {
          return
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        })
      },

      onUpdate(props) {
        component.updateProps(props)

        if (!props.clientRect) {
          return
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        })
      },
      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide()

          return true
        }
        return component.ref?.onKeyDown(props)
      },

      onExit() {
        popup[0].destroy()
        component.destroy()
      },
    }
  },
}